{
  "allApps": "所有应用程序",
  "back": "返回主",
  "myApps": "我的应用程序",
  "viewMoreApps": "视图更多应用程序"
}
